enum DateOperation {
  ADD_DAYS = 'ADD_DAYS',
  SUBTRACT_DAYS = 'SUBTRACT_DAYS'
}

export const DateOperationLabels: Record<DateOperation, string> = {
  [DateOperation.ADD_DAYS]: 'Add days',
  [DateOperation.SUBTRACT_DAYS]: 'Subtract days'
};

export default DateOperation;
